import React from 'react';
import {getPmDescriptionByCode, getPtDescriptionByCode, mapMessages} from '../lib/utils';
import {moment, formatters, DISPLAY_DATE_FORMAT, DISPLAY_DATE_TIME_FORMAT, $} from '../lib/ext-refs';
import BootstrapDialog from '../lib/bootstrap-dialog';

// Simple Bootstrap modal scaffolding
// handleClose - when modal is called
// handleAccept - when accept button is clicked
class AcceptAccountDialog extends React.Component {

    render() {
        const {config, payment} = this.props;
        const {messages, paymentConfig} = config;
        const recentPaymentMessages = mapMessages(messages, "opp.recentPaymentsModel.msg", 5);
        const recentPayments = payment.recentPayments;

        const fromDate = moment(payment.recentPaymentsDateFrom, 'MMDDYYYY').format('MM/DD/YYYY');
        const toDate = moment(payment.recentPaymentsDateTo, 'MMDDYYYY').format('MM/DD/YYYY');

        return (
            <BootstrapDialog aria-labelledby="modal-recent-payments-title"
                             aria-hidden="true"
                handleClose={this.props.handleClose}>
                <div className="modal-dialog modal-xl modal-notify modal-danger" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"
                                id="modal-recent-payments-title">
                                {messages["opp.recentPaymentsModal.title"]}
                                &mdash;
                                {payment.header.accountNumber}
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    {recentPaymentMessages.map((msg, idx) =>
                                        (<p key={idx}><strong>{msg}</strong></p>)
                                    )}
                                    <div className="payment-recent-container">
                                        <h4 className="subsection-title">
                                            {messages["opp.recentPaymentsTable.title"]}
                                            {' '}
                                            {fromDate}
                                            &mdash;
                                            {toDate}
                                        </h4>
                                        <table
                                            className="table table-recent-payment table-hover table-sm-custom table-bordered-simple">
                                            <thead>
                                            <tr>
                                                <th className="recent-payment-confirmation-col dark-grey-text text-nowrap">
                                                    {messages["opp.recentPaymentsTable.headerConfirmation"]}
                                                </th>
                                                <th className="recent-payment-type-col dark-grey-text text-nowrap">
                                                    {messages["opp.recentPaymentsTable.headerPaymentType"]}
                                                </th>
                                                <th className="recent-payment-amount-col dark-grey-text text-right text-nowrap">
                                                    {messages["opp.recentPaymentsTable.headerPaymentAmount"]}
                                                </th>
                                                <th className="recent-payment-amount-col dark-grey-text text-nowrap">
                                                    {messages["opp.recentPaymentsTable.headerPaymentDate"]}
                                                </th>
                                                <th className="recent-payment-method-col dark-grey-text text-nowrap">
                                                    {messages["opp.recentPaymentsTable.headerPaymentMethod"]}
                                                </th>
                                                <th className=" recent-status-col dark-grey-text text-nowrap">
                                                    {messages["opp.recentPaymentsTable.headerStatus"]}
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {recentPayments.filter((recentPayment) => {
                                                // Declined payments should not appear as a recent payment
                                                return recentPayment.header.paymentStatus !== 'DECLINED';
                                            }).map((recentPayment) => {
                                                let header = recentPayment.header;
                                                let paymentDate = header.paymentDate.toString();
                                                // if zero was truncated from the date, add it back
                                                if (paymentDate.length === 8) {
                                                    paymentDate = moment(paymentDate, 'MMDDYYYY').format(DISPLAY_DATE_FORMAT);
                                                } else {
                                                    paymentDate = moment(paymentDate, 'MMDDYYYYHHmmss').format(DISPLAY_DATE_TIME_FORMAT);
                                                }
                                                let pm = recentPayment.paymentMethod;
                                                return (
                                                    <tr key={header.referenceNumber}>
                                                        <td className="recent-payment-confirmation-col">{header.referenceNumber}</td>
                                                        <td className="recent-payment-type-col">
                                                            {getPtDescriptionByCode(paymentConfig, header.paymentTypeCode)}
                                                        </td>
                                                        <td className="recent-payment-amount-col dark-grey-text text-right">
                                                            ${formatters.addThousandSeparator(header.paymentAmount.toFixed(2))}
                                                        </td>
                                                        <td className="recent-payment-date-col">{paymentDate}</td>
                                                        <td className="recent-payment-method-col dark-grey-text">
                                                            {getPmDescriptionByCode(paymentConfig, pm.type)} {pm.maskedAccountNumber}
                                                        </td>
                                                        <td className="recent-status-col dark-grey-text">{header.paymentStatus}</td>
                                                    </tr>
                                                );
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer align-button-between-left">
                            <button type="button"
                                    className="btn btn-outline-danger btn-modal-cancel"
                                    data-dismiss="modal">
                                {messages["cancelButton.label"]}
                            </button>
                            <button type="button"
                                    className="btn btn-danger waves-effect btn-modal-confirm"
                                    data-dismiss="modal"
                                    onClick={this.props.handleAccept}
                            >
                                {messages["proceedButton.label"]}
                            </button>
                        </div>
                    </div>
                </div>
            </BootstrapDialog>
        );
    }
}

export default AcceptAccountDialog;